import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from '../../../shared/core-utils';
import { AlertService } from '../../../shared/alert/alert.service';
import { CharacterTraitInfo, TraitCondition } from '../../trait.reference.model';
import { MultiTraitQueryContext } from '../../multi-trait-query-context';
import { TraitFilterContext } from '../trait-filter-context';
import { TranslateService } from '@ngx-translate/core';
import { Weight } from '../../../shared/query/model/weight.model';


@Component({
    selector: 'jhi-character-traits-pane',
    templateUrl: 'character-traits-pane.component.html'
})
export class CharacterTraitsPaneComponent implements OnInit {
    isLoading: boolean;
    conditionOptions = [
        { label: 'multi-trait-query.condition.categorical.drop-trait', value: TraitCondition.DROP_TRAIT },
        { label: 'multi-trait-query.condition.categorical.keep-all', value: TraitCondition.KEEP_ALL },
        { label: 'multi-trait-query.condition.categorical.in', value: TraitCondition.IN },
        { label: 'multi-trait-query.condition.categorical.not.in', value: TraitCondition.NOT_IN }
    ];
    traitWeightOptions = [
        { label: 'multi-trait-query.environment.weight.important', value: Weight.IMPORTANT },
        { label: 'multi-trait-query.environment.weight.critical', value: Weight.CRITICAL },
        { label: 'multi-trait-query.environment.weight.desirable', value: Weight.DESIRABLE },
        { label: 'multi-trait-query.environment.weight.ignored', value: Weight.IGNORED }
    ];
    MAX_NAME_DISPLAY_SIZE = 30;
    protected readonly TraitCondition = TraitCondition;

    constructor(private jhiLanguageService: JhiLanguageService,
                private alertService: AlertService,
                public traitFilterContext: TraitFilterContext,
                public queryContext: MultiTraitQueryContext,
                private translateService: TranslateService) {
    }

    ngOnInit() {
    }

    isLimitsDisabled(characterTrait: CharacterTraitInfo): boolean {
        return characterTrait.condition === TraitCondition.DROP_TRAIT ||
            characterTrait.condition === TraitCondition.KEEP_ALL;
    }

    selectedCondition(characterTrait: CharacterTraitInfo) {
        if (characterTrait.condition === TraitCondition.DROP_TRAIT) {
            characterTrait.priority = Weight.IGNORED;
        } else {
            characterTrait.priority = Weight.IMPORTANT;
        }
    }

}
